/**
 * Apple-platform detection for keyboard-shortcut label rendering (⌘ vs Ctrl).
 *
 * `navigator.platform` is deprecated; prefer `userAgentData.platform`
 * (Chromium 90+) and fall back to the legacy property for Safari /
 * Firefox / iOS Safari which still don't ship UA-Data.
 *
 * The result is cached at module load — none of the call sites care
 * about runtime platform changes, and reading `navigator` on every key
 * label render added up across the composer / shortcuts overlay / context
 * menu / settings tab.
 */
const isApple = (() => {
  if (typeof navigator === 'undefined') return false;
  const ua = (
    navigator as Navigator & {
      userAgentData?: { platform?: string };
    }
  ).userAgentData;
  const platform = ua?.platform ?? navigator.platform ?? '';
  return /Mac|iPhone|iPad/.test(platform);
})();

export function isApplePlatform(): boolean {
  return isApple;
}

/** Modifier-key glyph used in keyboard hints — ⌘ on Apple, "Ctrl" elsewhere. */
export const MOD_KEY = isApple ? '⌘' : 'Ctrl';
